import {
  Card,
  CardActions,
  CardContent,
  CardHeader,
  CardProps,
  SxProps,
  Theme,
  Typography,
} from '@mui/material';
import { ReactNode } from 'react';

export interface StyledCardProps extends Omit<CardProps, 'children' | 'title'> {
  children: ReactNode;
  avatar?: ReactNode;
  title?: ReactNode;
  actions?: ReactNode | ReactNode[];
  size?: 'sm' | 'md';
  /** Styles merged into `CardContent` (after default padding). */
  contentSx?: SxProps<Theme>;
  withCardContent?: boolean;
}

export function StyledCard({
  children,
  avatar,
  title,
  actions,
  size = 'md',
  contentSx,
  elevation = 1,
  withCardContent = true,
  sx,
  ...cardProps
}: StyledCardProps) {
  const isSmall = size === 'sm';

  return (
    <Card elevation={elevation} sx={{ width: '100%', ...sx }} {...cardProps}>
      {(avatar || title) && (
        <CardHeader
          avatar={avatar}
          title={
            title ? (
              <Typography fontSize={isSmall ? '16px' : '18px'} fontWeight={500}>
                {title}
              </Typography>
            ) : undefined
          }
          sx={{
            '& .MuiCardHeader-avatar': {
              marginRight: 1,
            },
            px: isSmall ? 1.5 : 2,
            backgroundColor: 'grey.100',
            borderBottom: '1px solid',
            borderColor: 'grey.200',
          }}
        />
      )}
      {withCardContent ? (
        <CardContent sx={{ py: isSmall ? 1.5 : 2, ...contentSx }}>{children}</CardContent>
      ) : (
        children
      )}
      {actions && <CardActions sx={{ py: isSmall ? 0.5 : 1 }}>{actions}</CardActions>}
    </Card>
  );
}
